import {
  BrandSchema,
  UpdateBrandSchema,
} from "@redotech/redo-model/brand-types";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const updateBrand = unaryRpc({
  name: "updateBrand" as const,
  input: UpdateBrandSchema,
  output: z.object({ brand: BrandSchema }),
});
